import React, { useContext } from 'react';
export var IconButtonContext = /*#__PURE__*/React.createContext(null);
IconButtonContext.displayName = 'IconButtonContext';
export var useIconButtonContext = function useIconButtonContext() {
  return useContext(IconButtonContext);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/lmds-react-icons/dist/_esm/IconButtonContext.js
// module id = 935
// module chunks = 0